module.exports = __webpack_public_path__ + "static/img/11.02b260a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/11.png
// module id = U8+M
// module chunks = 0